import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '@libs/components/icons';

@Component({
  selector: 'ui-nav-controls-slide',
  templateUrl: './controls-slide.component.html',
  styleUrls: ['./controls-slide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconComponent,
  ],
})
export class ControlsSlideComponent {
  @Input() public current!: number | null;
  @Input() public max!: number | null;

  @Output() public slide: EventEmitter<number> = new EventEmitter<number>();
}
